import { Component, OnInit, OnDestroy } from '@angular/core';

import { environment } from '../environments/environment';

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

    production: boolean;

    defaultHost: string;

    constructor() {
        this.production = environment.production;
        this.defaultHost = environment.defaultHostV2;
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }
}
